import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SVGInline from 'react-svg-inline';
import YouTube from 'react-youtube';
// import Vimeo from  'react-vimeo';

// utils
import { getYoutubeId, isVideo, vimeo_parser } from '../../../../utils';

// components

// svgs
import videoPlayButton from '../../../inlineSVGs/videoPlayButtonSVG';

// styles
import './Media.css';

// const MEDIA_REL_SIZE_WIDTH = 1.3;
// const MEDIA_REL_SIZE_HEIGHT = 1.3;

class Media extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isPlaying: false,
            isReady: false,
            selectedMedia: 0,
        };
    }

    componentDidMount() {
        if (this.props.media && this.props.media.length > 1 && this.props.media[0] && this.props.media[0] === 'false') {
            this.setState({ selectedMedia: 1})
        }
    }

    getVideoYTId() {
        // url sturct = https://www.youtube.com/embed/D0W1v0kOELA
        return getYoutubeId(this.props.media[0]) || '';
    }

    getVideoVimeoUrl() {
        return vimeo_parser(this.props.media[0] || '');
    }

    onPlayerReady(event) {
        this.setState({ytPlayer: event.target, isReady: true});
    }

    onPause(event) {
        this.setState({isPlaying: false});
    }

    onPlay(event) {
        this.setState({isPlaying: true});
    }

    // https://www.youtube.com/embed/D0W1v0kOELA
    // TODO: not all videos have max quality thumbnails - how to check?
    // https://i.ytimg.com/vi/D0W1v0kOELA/maxresdefault.jpg
    // https://i.ytimg.com/vi/D0W1v0kOELA/hqdefault.jpg

    handleThumbnailClick() {
        // remove thumbnail and show video
        // this.setState({isPlaying: !this.state.isPlaying});

        if (!this.state.ytPlayer || !this.state.isReady) return;

        this.state.ytPlayer.playVideo();
    }

    renderEmbeddedVideoYT(id) {
        const opts = {
            height: this.props.mainMediaHeight.toString(),
            width: this.props.mainMediaWidth.toString(),
            playerVars: { // https://developers.google.com/youtube/player_parameters
                autoplay: 0,
                showInfo: 0
            }
        };

        return (
            <YouTube
                className={this.state.isPlaying ? 'show' : 'show'}
                videoId={id}
                opts={opts}
                onReady={e => this.onPlayerReady(e)}
                onPause={e => this.onPause(e)}
                onPlay={e => this.onPlay(e)}
            />
        )
    }

    renderEmbeddedVideoVimeo(vimeoUrl) {
        return (
            <iframe
                className="show"
                width={this.props.mainMediaWidth.toString()}
                height={this.props.mainMediaHeight.toString()}
                frameBorder="0"
                src={vimeoUrl}
                title={vimeoUrl}
            ></iframe>
        )

        // const opts = {
        //     id,
        //     width: 900,
        //     height: 400
        // };

        // return (
        //     <Vimeo
        //         className="show"
        //         videoId={id}
        //         playerOptions={opts}
        //         onReady={e => this.onPlayerReady(e)}
        //         onPause={e => this.onPause(e)}
        //         onPlay={e => this.onPlay(e)}
        //     />
        // )
    }

    handleMediaClick(e) {
        this.setState({selectedMedia: e, isPlaying: false});
    }

    // TODO: not in use for now
    renderVideoThumbnail(ytId, vimeoUrl) {
        if (!ytId && !vimeoUrl) return null;

        if (ytId) {
            return (
                <div
                    onClick={() => this.handleThumbnailClick()}
                    className={`thumbnail video ${this.props.type}`}
                    style={{
                        backgroundImage: `url("https://i.ytimg.com/vi/${ytId}/maxresdefault.jpg")`,
                        width: this.props.mainMediaWidth,
                        height: this.props.mainMediaHeight,
                        display: this.state.isPlaying ? 'none' : 'flex'
                    }} >
                    <SVGInline className="play-icon" svg={videoPlayButton} component="i"/>
                </div>
            )
        }

        // vimeo thumbnail
        return (
            <div
                onClick={() => this.handleThumbnailClick()}
                className={`thumbnail video ${this.props.type}`}
                style={{
                    backgroundImage: `url("${this.props.vimeoThumbnailUrl}")`,
                    width: this.props.mainMediaWidth,
                    height: this.props.mainMediaHeight,
                    display: this.state.isPlaying ? 'none' : 'flex'
                }} >
                <SVGInline className="play-icon" svg={videoPlayButton} component="i"/>
            </div>
        )
    }

    // https://i.vimeocdn.com/video/769977796_640.webp
    renderSelectedMedia(videoYTId, vimeoUrl) {
        if (!this.props.media) return null;

        // if (!videoYTId && !vimeoUrl) return null;
        let selectedMedia = this.props.media[0];

        if (!selectedMedia) return null;

        if (this.state.selectedMedia > 0 && this.props.media.length > 0 && this.props.media[this.state.selectedMedia]) {
            selectedMedia = this.props.media[this.state.selectedMedia];
        }

        // render image if there is no video
        // 'false' string is a bug that was fixed living here the check for old ads
        if (!isVideo(selectedMedia)) {
            // if (!selectedMedia.includes('http')) return null;

            const imgUrl = selectedMedia || this.props.media[this.state.selectedMedia + 1];

            return (
                <div className="selected-media-wrapper">
                    <div
                        className={`thumbnail ${this.props.type}`}
                        style={{
                            backgroundImage: `url("${imgUrl}")`,
                            width: this.props.mainMediaWidth,
                            height: this.props.mainMediaHeight
                        }} >
                    </div>
                </div>
            )
        }

        // check if youtube or vimeo video
        if (vimeoUrl) {
            return (
                <div className="selected-media-wrapper">
                    {/*{this.renderVideoThumbnail('', vimeoUrl)}*/}
                    {this.renderEmbeddedVideoVimeo(vimeoUrl)}
                </div>
            )
        }

        if (videoYTId) {
            // render video if there is one
            return (
                <div className="selected-media-wrapper">
                    {/*{this.renderVideoThumbnail(videoYTId)}*/}
                    {this.renderEmbeddedVideoYT(videoYTId)}
                </div>
            )
        }

        return null;

    }

    renderMediaSelector(videoYTId, videoVimeoUrl) {
        if (!this.props.media) return null;

        return (
            <div className={`media-selector-wrapper ${this.props.media.length < 5 ? 'short': ''}`}>
                {this.props.media.map((m, i) => {
                    if (!m.includes('http') || m === this.props.media[this.state.selectedMedia]) return null;

                    if (!isVideo(m)){
                        // if not any video show images if any
                        return (
                            <div
                                key={`media-selector-${i}`}
                                className="media-slot"
                                style={{backgroundImage: `url("${m}")`}}
                                onClick={() => this.handleMediaClick(i)}
                            >
                            </div>
                        )
                    }

                    // videoYTId means also that this is a Youtube video - bad naming
                    if (videoYTId) {
                        return (
                            <div
                                key={`media-selector-${i}`}
                                className={`media-slot ${this.props.type}`}
                                style={{backgroundImage: `url("https://i.ytimg.com/vi/${videoYTId}/maxresdefault.jpg")`}}
                                onClick={() => this.handleMediaClick(i)}
                            >
                                <SVGInline className="play-icon-small" svg={videoPlayButton} component="i"/>
                            </div>
                        )
                    }

                    if (videoVimeoUrl) {
                        // show here Vimeo thumbnail from pin data
                        return (
                            <div
                                key={`media-selector-${i}`}
                                className={`media-slot ${this.props.type}`}
                                style={{backgroundImage: `url("${this.props.vimeoThumbnailUrl}")`}}
                                onClick={() => this.handleMediaClick(i)}
                            >
                                <SVGInline className="play-icon-small" svg={videoPlayButton} component="i"/>
                            </div>
                        )
                    }

                    return null;
                })}
            </div>
        )
    }

    render() {
        const videoYTId = this.getVideoYTId();
        const videoVimeoUrl = this.getVideoVimeoUrl();

        return (
            <div className="modal-media-wrapper" style={this.props.wrapperStyle}>
                {this.renderSelectedMedia(videoYTId, videoVimeoUrl)}
                {this.renderMediaSelector(videoYTId, videoVimeoUrl)}
            </div>
        )
    }
}

Media.propTypes = {
    mainMediaWidth: PropTypes.number,
    mainMediaHeight: PropTypes.number,
    media: PropTypes.array,
    type: PropTypes.string,
    vimeoThumbnailUrl: PropTypes.string,
    wrapperStyle: PropTypes.object
};

Media.defaultProps = {
    mainMediaWidth: 500,
    mainMediaHeight: 400
};

export default Media;



// WEBPACK FOOTER //
// ./src/Components/ModalsNew/ModalElements/Media/Media.js